import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { ReactComponent as InfLogo4 } from "../../../assets/inf-element-cod.svg";
import { ReactComponent as InfLogo } from "../../../assets/inf-element-cs.svg";
import { ReactComponent as InfLogo5 } from "../../../assets/inf-element-deadlock.svg";
import { ReactComponent as InfLogo3 } from "../../../assets/inf-element-dota.svg";
import { ReactComponent as InfLogo6 } from "../../../assets/inf-element-fifa.svg";
import { ReactComponent as InfLogo7 } from "../../../assets/inf-element-LOL.svg";
import { ReactComponent as InfLogo2 } from "../../../assets/inf-element-valorant.svg";
import { ReactComponent as InfLogo8 } from "../../../assets/inf-element-wot.svg";
import SlideIn from "../../ui/SlideIn/SlideIn.js";
import "./EventsStyles.scss";

const SWIPE_EASE = "cubic-bezier(0.32, 0.72, 0, 1)";
const SWIPE_MS = 340;
const PEEK_PX = 24;
const GAP_PX = 10;

const createEventData = (t) => ({
	"2022": {
		"PARI Night": {
			logo: require("../../../assets/event-PariNightLogo2.webp"),
			title: "PARI White Night LAN",
			description: t("eventData2022.PARI-Night.description"),
			game: "CS2",
			date: "July 18, 2022 - July 20, 2022",
			prize: "10,000",
		},
		"PARI Patriki": {
			logo: require("../../../assets/event-PariPatrikiLogo2.webp"),
			title: "PARI Patriki Vibe LAN",
			description: t("eventData2022.PARI-Patriki.description"),
			game: "CS2",
			date: "Sept 12, 2022 - Sept 15, 2022",
			prize: "10,000",
		},
		"PARI Rio": {
			logo: require("../../../assets/event-PariRioLogo2.webp"),
			title: "PARI After Rio LAN",
			description: t("eventData2022.PARI-Rio.description"),
			game: "CS2",
			date: "Dec 1, 2022 - Dec 4, 2022",
			prize: "10,000",
		},
	},
	"2023": {
		"FME 2-4": {
			logo: require("../../../assets/event-FonBetLogo2.webp"),
			title: "Fonbet Media Eleague Season 2-4",
			description: t("eventData2023.FME-2-4.description"),
			game: "CS2",
			date: "May 28, 2023 - Aug 20, 2023",
			prize: "20,000",
		},
		"GL LAN": {
			logo: require("../../../assets/event-GlLanLogo2.webp"),
			title: "GLUCK SPRING LAN 2023",
			description: t("eventData2023.GL-LAN.description"),
			game: "CS2",
			date: "Jun 10, 2023 - Jun 11, 2023",
			prize: "5,000",
		},
		"Dunav Party": {
			logo: require("../../../assets/event-PariDunavLogo2.webp"),
			title: "Dunav Party LAN",
			description: t("eventData2023.Dunav-Party.description"),
			game: "CS2",
			date: "Aug 24, 2023 - Aug 27, 2023",
			prize: "50,000",
		},
		"BB All-Star": {
			logo: require("../../../assets/event-BbStarLogo.webp"),
			title: "BetBoom All-Star 5x5",
			description: t("eventData2023.BB-All-Star.description"),
			game: "CS2",
			date: "Sept 14, 2023 - Sept 17, 2023",
			prize: "5,000",
		},
		"HP Cup #7": {
			logo: require("../../../assets/event-HpCupLogo2.png"),
			title: "Hard Play Cup #7",
			description: t("eventData2023.HP-Cup-#7.description"),
			game: "CS2",
			date: "Sept 22, 2023 - Sept 24, 2023",
			prize: "7,500",
		},
		"FME 5": {
			logo: require("../../../assets/event-FonBetLogo2.webp"),
			title: "Fonbet Media Eleague Season 5",
			description: t("eventData2023.FME-5.description"),
			game: "CS2",
			date: "Oct 2, 2023 - Oct 7, 2023",
			prize: "20,000",
		},
		"BB 5x5": {
			logo: require("../../../assets/event-BbStarLogo2.webp"),
			title: "BetBoom ShowMatch 5x5",
			description: t("eventData2023.BB-5x5.description"),
			game: "Valorant",
			date: "Oct 9, 2023 - Oct 9, 2023",
			prize: "20,000",
		},
		Colizeum: {
			logo: require("../../../assets/event-ColizeumLogo2.webp"),
			title: "Colizeum",
			description: t("eventData2023.Colizeum.description"),
			date: "Oct 12, 2023 - Oct 17, 2023",
		},
		"Copa BB": {
			logo: require("../../../assets/event-CopaBbLogo2.webp"),
			title: "Copa BetBoom 2023",
			description: t("eventData2023.Copa-BB.description"),
			game: "CS2",
			date: "Oct 21, 2023 - Nov 4, 2023",
			prize: "40,000",
		},
		"HP Cup #8": {
			logo: require("../../../assets/event-HpCupLogo2.webp"),
			title: "Hard Play Cup #8",
			description: t("eventData2023.HP-Cup-#8.description"),
			game: "CS2",
			date: "Nov 11, 2023 - Nov 12, 2023",
			prize: "7,500",
		},
		"PARI Please": {
			logo: require("../../../assets/event-PariPleaseLogo2.webp"),
			title: "PARI, Please",
			description: t("eventData2023.PARI-Please.description"),
			game: "CS2",
			date: "Nov 16, 2023 - Nov 20, 2023",
			prize: "100,000",
		},
		"BB Dacha": {
			logo: require("../../../assets/event-BbDachaEVNLogo2.webp"),
			title: "BetBoom Dacha",
			description: t("eventData2023.BB-Dacha.description"),
			game: "CS2",
			date: "Dec 5, 2023 - Dec 10, 2023",
			prize: "300,000",
		},
		"BB Valorant": {
			logo: require("../../../assets/event-BbValorantLogo2.webp"),
			title: "BetBoom Showmatch 5x5 Valorant",
			description: t("eventData2023.BB-Valorant.description"),
			game: "Valorant",
			date: "Dec 25, 2023 - Dec 25, 2023",
			prize: "5,000",
		},
	},
	"2024": {
		"Golovin Cup": {
			logo: require("../../../assets/event-WarzoneCupLogo2.webp"),
			title: "Golovin Warzone Cup",
			description: t("eventData2024.Golovin-Cup.description"),
			game: "COD",
			date: "Jan 6, 2024 - Jan 6, 2024",
			prize: "6,500",
		},
		"BB Battle 5": {
			logo: require("../../../assets/event-BbStreamersLogo2.webp"),
			title: "BetBoom Streamers Battle 5",
			description: t("eventData2024.BB-Battle-5.description"),
			game: "Dota 2",
			date: "Jan 22, 2024 - Jan 28, 2024",
			prize: "23,000",
		},
		RES: {
			logo: require("../../../assets/event-RESLogo2.webp"),
			title: "RES Regional Champions 2024",
			description: t("eventData2024.RES.description"),
			game: "CS2",
			date: "Feb 15, 2024 - Oct 19, 2024",
			prize: "250,000",
		},
		"BB League": {
			logo: require("../../../assets/event-BbValorant24Logo2.webp"),
			title: "BetBoom VALORANT League",
			description: t("eventData2024.BB-League.description"),
			game: "Valorant",
			date: "Mar 9, 2024 - Mar 10, 2024",
			prize: "7,000",
		},
		FME: {
			logo: require("../../../assets/event-FonBetLogo2.webp"),
			title: "Fonbet Media Eleague Season 6",
			description: t("eventData2024.FME.description"),
			game: "CS2",
			date: "Apr 1, 2024 - Apr 7, 2024",
			prize: "22,000",
		},
		ROFLOTURIK: {
			logo: require("../../../assets/event-RoflCupLogo2.webp"),
			title: t("eventData2024.ROFLOTURIK.title"),
			description: t("eventData2024.ROFLOTURIK.description"),
			game: "CS2",
			date: "Apr 19, 2024 - Apr 21, 2024",
			prize: "10,000",
		},
		CCT: {
			logo: require("../../../assets/event-CCTS2Logo2.webp"),
			title: "CCT Season 2",
			description: t("eventData2024.CCT.description"),
			game: "CS2",
			date: "Apr 15, 2024 - Now",
			prize: "50,000",
		},
		"BB Dacha": {
			logo: require("../../../assets/event-BbDachaBEGLogo2.webp"),
			title: "BetBoom Dacha Belgrade 2024",
			description: t("eventData2024.BB-Dacha.description"),
			game: "CS2",
			date: "May 14, 2024 - May 19, 2024",
			prize: "500,000",
		},
		RCA: {
			logo: require("../../../assets/event-RCALogo2.png"),
			title: "Regional Clash Arena",
			description: t("eventData2024.RCA.description"),
			game: "CS2",
			date: "March 25, 2024 - Jun 17, 2024",
			prize: "180,000",
		},
		Aunkere: {
			logo: require("../../../assets/event-AunkereCupLogo2.webp"),
			title: "Aunkere Cup",
			description: t("eventData2024.Aunkere.description"),
			game: "CS2",
			date: "Jun 21, 2024 - Jun 23, 2024",
			prize: "24,000",
		},
		"BB League SU": {
			logo: require("../../../assets/event-BbValorantSmLogo2.png"),
			title: "BetBoom VALORANT League: Summer",
			description: t("eventData2024.BB-League-SU.description"),
			game: "Valorant",
			date: "Jun 24, 2024 - Jun 29, 2024",
			prize: "12,000",
		},
		"FME Dota2": {
			logo: require("../../../assets/event-FMEDota22.webp"),
			title: "Fonbet Media Eleague Dota 2",
			description: t("eventData2024.FME-Dota2.description"),
			game: "Dota 2",
			date: "Aug 22, 2024 - Aug 27, 2024",
			prize: "22,000",
		},
		"BB Dacha #2": {
			logo: require("../../../assets/event-BbDachaBEG2Logo2.webp"),
			title: "BetBoom Dacha Belgrade 2024 #2",
			description: t("eventData2024.BB-Dacha-#2.description"),
			game: "CS2",
			date: "Aug 24, 2024 - Sep 01, 2024",
			prize: "505,000",
		},
		"Recrent Cup": {
			logo: require("../../../assets/event-RecrentCup2.webp"),
			title: "RECRENT PARI CUP DOTA 2",
			description: t("eventData2024.Recrent-Cup.description"),
			game: "Dota 2",
			date: "Aug 29, 2024 - Aug 29, 2024",
			prize: "10,000",
		},
		DEADLOCK: {
			logo: require("../../../assets/event-DeadLockCup2.webp"),
			title: "BetBoom DEADLOCK CUP",
			description: t("eventData2024.DEADLOCK.description"),
			game: "Deadlock",
			date: "Sep 03, 2024 - Sep 03, 2024",
			prize: "6,800",
		},
		"CSGORUN S1": {
			logo: require("../../../assets/event-CSGORUN2.webp"),
			title: "FASTCUP: CSGORUN Cup Season 1",
			description: t("eventData2024.CSGORUN-S1.description"),
			game: "CS2",
			date: "Sep 14, 2024 - Sep 24, 2024",
			prize: "55,000",
		},
		"DEADLOCK #2": {
			logo: require("../../../assets/event-DeadLockCup2.webp"),
			title: "BetBoom DEADLOCK CUP #2",
			description: t("eventData2024.DEADLOCK-#2.description"),
			game: "Deadlock",
			date: "Sep 21, 2024 - Sep 22, 2024",
			prize: "10,000",
		},
		"BB League FL": {
			logo: require("../../../assets/event-BbValorantSmLogo2.webp"),
			title: "BetBoom VALORANT League: Fall",
			description: t("eventData2024.BB-League-FL.description"),
			game: "Valorant",
			date: "Sep 30, 2024 - Oct 05, 2024",
			prize: "10,000",
		},
		"BB All-Star": {
			logo: require("../../../assets/event-BBAllStar2x22.webp"),
			title: "BetBoom All-Star 2x2 #2",
			description: t("eventData2024.BB-All-Star.description"),
			game: "CS2",
			date: "Oct 11, 2024 - Oct 12, 2024",
			prize: "10,000",
		},
		"FME 7": {
			logo: require("../../../assets/event-FonBetLogo2.webp"),
			title: "Fonbet Media Eleague Season 7",
			description: t("eventData2024.FME-7.description"),
			game: "CS2",
			date: "Oct 23, 2024 - Oct 29, 2024",
			prize: "20,000",
		},
		"DEADLOCK #3": {
			logo: require("../../../assets/event-DeadLockCup2.webp"),
			title: "BetBoom DEADLOCK CUP #3",
			description: t("eventData2024.DEADLOCK-#3.description"),
			game: "Deadlock",
			date: "Nov 14, 2024 - Nov 15, 2024",
			prize: "10,000",
		},
		"FME 8": {
			logo: require("../../../assets/event-FMEDeadlock.png"),
			title: "Fonbet Media Eleague DEADLOCK",
			description: t("eventData2024.FME-DEADLOCK.description"),
			game: "Deadlock",
			date: "Dec 23, 2024 - Dec 24, 2024",
			prize: "10,000",
		},
		"Aunkere #2": {
			logo: require("../../../assets/event-BB-aunkerecup-2.png"),
			title: "BetBoom Aunkere Cup 2x2",
			description: t("eventData2024.Aunkere-2x2.description"),
			game: "CS2",
			date: "Dec 27, 2024 - Dec 28, 2024",
			prize: "10,000",
		},
	},
	"2025": {
		"Woman Cup": {
			logo: require("../../../assets/event-WomanCup.png"),
			title: "BetBoom Woman Cup",
			description: t("eventData2025.Woman-cup.description"),
			game: "CS2",
			date: "Jan 9, 2025 - Jan 11, 2025",
			prize: "10,000",
		},
		LanDaLan: {
			logo: require("../../../assets/event-LanDaLan.png"),
			title: "BetBoom LanDaLan",
			description: t("eventData2025.LanDaLan.description"),
			game: "CS2",
			date: "Feb 10, 2025 - Feb 13, 2025",
			prize: "10,000",
		},
		"MelBet ML": {
			logo: require("../../../assets/event-Melbet.png"),
			title: "MelBet Media League",
			description: t("eventData2025.Melbet.description"),
			game: "CS2",
			date: "Feb 16, 2025 - Mar 16, 2025",
			prize: "20,000",
		},
		"Egoisto Cup": {
			logo: require("../../../assets/event-BBEgoistoCup.png"),
			title: "BetBoom Egoisto Cup",
			description: t("eventData2025.EgoistoCup.description"),
			game: "Dota 2",
			date: "Mar 7, 2025 - Mar 8, 2025",
			prize: "5,600",
		},
		"FC CUP SE2": {
			logo: require("../../../assets/event-FC-cup2.png"),
			title: "BetBoom FC Streamers Cup SE 2",
			description: t("eventData2025.FC-CUP.description"),
			game: "FC 25",
			date: "Mar 26, 2025 - Mar 28, 2025",
			prize: "5,000",
		},
		"FME Dota2": {
			logo: require("../../../assets/event-FMEDota22.webp"),
			title: "Fonbet Media Eleague Dota 2 SE2",
			description: t("eventData2025.FME-Dota2.description"),
			game: "Dota 2",
			date: "Mar 28, 2025 - Apr 2, 2025",
			prize: "24,000",
		},
		"Noxus League": {
			logo: require("../../../assets/event-NoxusLeague.png"),
			title: "Noxus League 2025",
			description: t("eventData2025.NoxusLeague.description"),
			game: "LOL",
			date: "Apr 25, 2025 - Apr 27, 2025",
			prize: "10,000",
		},
		"Proving Grounds": {
			logo: require("../../../assets/event-ProvingGrounds.png"),
			title: "Exort The Proving Grounds",
			description: t("eventData2025.ProvingGrounds.description"),
			game: "CS2",
			date: "May 6, 2025 - Aug 22, 2025",
			prize: "260,000",
		},
		"FC CUP SE3": {
			logo: require("../../../assets/event-FC-cup3.png"),
			title: "BetBoom FC Streamers Cup #3",
			description: t("eventData2025.FC-CUP3.description"),
			game: "FC 25",
			date: "May 6, 2025 - May 8, 2025",
			prize: "6,300",
		},
		"LanDaLan 2": {
			logo: require("../../../assets/event-LanDaLan2.png"),
			title: "LanDaLan #2",
			description: t("eventData2025.LanDaLan2.description"),
			game: "CS2",
			date: "May 5, 2025 - May 8, 2025",
			prize: "50,000",
		},
		Playground: {
			logo: require("../../../assets/event-Playground1.png"),
			title: "FISSURE Playground #1",
			description: t("eventData2025.Playground1.description"),
			game: "CS2",
			date: "Jul 15, 2025 - Jul 20, 2025",
			prize: "1,000,000",
		},
		"Rivals Dota2": {
			logo: require("../../../assets/event-RivalsDota.png"),
			title: "Pari Rivals Dota 2",
			description: t("eventData2025.RivalsDota.description"),
			game: "Dota 2",
			date: "Jun 18, 2025 - Jun 20, 2025",
			prize: "12,600",
		},
		"Rivals CS2": {
			logo: require("../../../assets/event-RivalsCS2.png"),
			title: "Pari Rivals CS2 2.0",
			description: t("eventData2025.RivalsCS2.description"),
			game: "CS2",
			date: "Jun 30, 2025 - Jul 1, 2025",
			prize: "12,600",
		},
		"Star Strike": {
			logo: require("../../../assets/event-KHLStrike.png"),
			title: "KHL Star Strike Season 2",
			description: t("eventData2025.KHLStrike.description"),
			game: "CS2",
			date: "Jul 19, 2025 - Jul 20, 2025",
			prize: "7,000",
		},
		"FME Dota2 #3": {
			logo: require("../../../assets/event-FMEDota22.webp"),
			title: "Fonbet Media Eleague Dota 2 SE3",
			description: t("eventData2025.FME-Dota2.description"),
			game: "Dota 2",
			date: "Jul 24, 2025 - Jul 29, 2025",
			prize: "38,000",
		},
		"CIS Battle": {
			logo: require("../../../assets/event-CISBattle.png"),
			title: "CIS Battle Dota 2",
			description: t("eventData2025.CISBattle.description"),
			game: "Dota 2",
			date: "Aug 2, 2025 - Aug 15, 2025",
			prize: "15,000",
		},
		"FME CS S8": {
			logo: require("../../../assets/LOGO FME.png"),
			title: "FONBET MEDIA ELEAGUE CS Season 8",
			description: t("eventData2025.FME-CS-S8.description"),
			game: "CS2",
			date: "Aug 25, 2025 - Sep 3, 2025",
			prize: "39,100",
		},
		"Woman Cup 2": {
			logo: require("../../../assets/LOGO W CUP2.png"),
			title: "BetBoom Woman Cup 2",
			description: t("eventData2025.Woman-cup-2.description"),
			game: "CS2",
			date: "Sep 22, 2025 - Sep 23, 2025",
			prize: "13,050",
		},
		"Mixer Cup": {
			logo: require("../../../assets/LOGO MIXER CUP.png"),
			title: "Mixer Cup",
			description: t("eventData2025.Mixer-Cup.description"),
			game: "Dota 2",
			date: "Sep 22, 2025 - Sep 24, 2025",
		},
		"LanDaLan 3": {
			logo: require("../../../assets/LOGO LDL3.png"),
			title: "Majestic LanDaLan 3",
			description: t("eventData2025.LanDaLan3.description"),
			game: "CS2",
			date: "Sep 25, 2025 - Sep 28, 2025",
			prize: "50,000",
		},
		"BB Valorant FL": {
			logo: require("../../../assets/LOGO VALORANT.png"),
			title: "BetBoom Valorant League: Fall 2025",
			description: t("eventData2025.BB-Valorant-FL.description"),
			game: "Valorant",
			date: "Nov 6, 2025 - Nov 9, 2025",
			prize: "12,300",
		},
		STAYA: {
			logo: require("../../../assets/LOGO STAYA.png"),
			title: "STAYA X Сборная России",
			description: t("eventData2025.STAYA.description"),
			game: "FC 26",
			date: "Nov 14, 2025 - Nov 14, 2025",
			prize: t("eventData2025.STAYA.prize"),
		},
		"BB Esports Cup": {
			logo: require("../../../assets/LOGO BB ESPORTS.png"),
			title: "BetBoom Esports Cup",
			description: t("eventData2025.BB-Esports-Cup.description"),
		},
	},
	"2026": {
		"CIS LAN #3": {
			logo: require("../../../assets/CIS LAN 3 LOGO.png"),
			title: "CIS LAN #3",
			description: t("eventData2026.CIS-LAN-3.description"),
			game: "CS2",
			date: "Mar 9, 2026 - Mar 12, 2026",
			prize: "20,000",
		},
		"Rofl Battle": {
			logo: require("../../../assets/LOGO ROFL.png"),
			title: "Rofl Streamers Battle",
			description: t("eventData2026.Rofl-Battle.description"),
			game: "CS2",
			date: "Mar 16, 2026 - Mar 17, 2026",
			prize: "30,000",
		},
		"FME S4": {
			logo: require("../../../assets/LOGO FME.png"),
			title: "FONBET MEDIA ELEAGUE Season 4",
			description: t("eventData2026.FME-S4.description"),
			game: "Dota 2",
			date: "Apr 1, 2026 - Apr 10, 2026",
			prize: "39,100",
		},
		"CIS LAN #4": {
			logo: require("../../../assets/CIS LAN 4 LOGO.png"),
			title: "CIS LAN #4",
			description: t("eventData2026.CIS-LAN-4.description"),
			game: "CS2",
			date: "Apr 2, 2026 - Apr 5, 2026",
			prize: "50,000",
		},
		"BSB #13": {
			logo: require("../../../assets/LOGO BSB CS.png"),
			title: "BetBoom Streamers Battle #13",
			description: t("eventData2026.BSB-13.description"),
			game: "Dota 2",
			date: "May 18, 2026 - May 24, 2026",
			prize: "55,700",
		},
		"CS Asia": {
			logo: require("../../../assets/CS_Asia_Championships.png"),
			title: "CS Asia Championships 2026",
			description: t("eventData2026.CS-Asia.description"),
			game: "CS2",
			date: "May 20, 2026 - May 24, 2026",
			prize: "1,000,000",
		},
		"CIS LAN #5": {
			logo: require("../../../assets/CIS LAN 5 LOGO.png"),
			title: "CIS LAN #5 White Nights",
			description: t("eventData2026.CIS-LAN-5.description"),
			game: "CS2",
			date: "May 25, 2026 - May 28, 2026",
			prize: "30,000",
		},
		"RWB Cup": {
			logo: require("../../../assets/LOGO RWB.png"),
			title: "RWB Cyber Cup CS2",
			description: t("eventData2026.RWB-Cup.description"),
			game: "CS2",
			date: "Jun 5, 2026 - Jun 7, 2026",
		},
		"SQUAD BATTLE": {
			logo: require("../../../assets/logo-site.png"),
			title: "SQUAD BATTLE",
			description: t("eventData2026.SQUAD-BATTLE.description"),
			game: "World of Tanks",
			date: "Jun 20, 2026 - Jun 21, 2026",
		},
		"BSB #5": {
			logo: require("../../../assets/LOGO BSB CS.png"),
			title: "BetBoom Streamers Battle #5",
			description: t("eventData2026.BSB-5.description"),
			game: "CS2",
			date: "Jun 29, 2026 - Jul 4, 2026",
			prize: "50,000",
		},
		"CIS LAN #6": {
			logo: require("../../../assets/CIS LAN 6 LOGO.png"),
			title: "WINLINE CIS LAN #6",
			description: t("eventData2026.CIS-LAN-6.description"),
			game: "CS2",
			date: "Jul 27, 2026 - Jul 30, 2026",
			prize: "40,000",
		},
	},
});
function Events() {
	const { t } = useTranslation();
	const allEventData = useMemo(() => createEventData(t), [t]);

	const [activeYear, setActiveYear] = useState("2026");
	const [activeEvent, setActiveEvent] = useState("");
	const [dragX, setDragX] = useState(0);
	const [isDragging, setIsDragging] = useState(false);
	const [hasInteracted, setHasInteracted] = useState(false);
	const isAnimatingRef = useRef(false);
	const skipTransitionRef = useRef(false);
	const animTimeoutRef = useRef(null);
	const axisLockRef = useRef(null); // "x" | "y" | null
	const unitRef = useRef(0);
	const eventsRef = useRef([]);
	const activeEventRef = useRef("");

	useEffect(() => {
		const eventsForYear = allEventData[activeYear];
		if (eventsForYear) {
			const firstEventKey = Object.keys(eventsForYear)[0];
			setActiveEvent(firstEventKey);
		}
		setDragX(0);
		setIsDragging(false);
		isAnimatingRef.current = false;
		skipTransitionRef.current = false;
		axisLockRef.current = null;
		if (animTimeoutRef.current) {
			clearTimeout(animTimeoutRef.current);
			animTimeoutRef.current = null;
		}
	}, [activeYear, allEventData]);

	const events = useMemo(
		() =>
			allEventData[activeYear]
				? Object.keys(allEventData[activeYear])
				: [],
		[allEventData, activeYear]
	);

	eventsRef.current = events;
	activeEventRef.current = activeEvent;

	const handleYearClick = (year) => {
		setActiveYear(year);
	};

	const resetDragState = useCallback(() => {
		setIsDragging(false);
		setDragX(0);
		axisLockRef.current = null;
	}, []);

	const handleSegmentClick = (index) => {
		if (!events[index] || events[index] === activeEvent) return;
		setHasInteracted(true);
		if (animTimeoutRef.current) {
			clearTimeout(animTimeoutRef.current);
			animTimeoutRef.current = null;
		}
		isAnimatingRef.current = false;
		skipTransitionRef.current = true;
		resetDragState();
		setActiveEvent(events[index]);
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				skipTransitionRef.current = false;
			});
		});
	};

	const getGameLogo = (game) => {
		switch (game) {
			case "CS2":
				return <InfLogo />;
			case "Valorant":
				return <InfLogo2 />;
			case "Dota 2":
				return <InfLogo3 />;
			case "COD":
				return <InfLogo4 />;
			case "Deadlock":
				return <InfLogo5 />;
			case "FC 25":
			case "FC 26":
				return <InfLogo6 />;
			case "LOL":
				return <InfLogo7 />;
			case "World of Tanks":
				return <InfLogo8 />;
			default:
				return null;
		}
	};

	const isMobile = useMediaQuery({ maxWidth: 576 });
	const carouselRef = useRef(null);
	const textRef = useRef(null);
	const [carouselWidth, setCarouselWidth] = useState(0);
	const [textWidth, setTextWidth] = useState(0);

	useEffect(() => {
		if (!isMobile) return undefined;
		const carouselEl = carouselRef.current;
		const textEl = textRef.current;
		if (!carouselEl) return undefined;

		const measure = () => {
			setCarouselWidth(carouselEl.offsetWidth || 0);
			setTextWidth(textEl?.offsetWidth || 0);
		};
		measure();
		const ro = new ResizeObserver(measure);
		ro.observe(carouselEl);
		if (textEl) ro.observe(textEl);
		return () => ro.disconnect();
	}, [isMobile, activeYear, activeEvent]);

	const slideSize =
		textWidth > 0
			? textWidth
			: Math.max(0, carouselWidth - PEEK_PX * 2);
	const gap = GAP_PX;
	const unit = slideSize + gap;
	const peek =
		carouselWidth > 0 && slideSize > 0
			? Math.max(0, (carouselWidth - slideSize) / 2)
			: PEEK_PX;
	const baseX = peek - unit;
	unitRef.current = unit;

	const commitSwipe = useCallback(
		(nextIndex, direction) => {
			if (isAnimatingRef.current) return;
			const u = unitRef.current;
			const list = eventsRef.current;
			if (!u || !list[nextIndex]) return;

			isAnimatingRef.current = true;
			setIsDragging(false);
			setDragX(direction < 0 ? -u : u);

			if (animTimeoutRef.current) clearTimeout(animTimeoutRef.current);
			animTimeoutRef.current = window.setTimeout(() => {
				skipTransitionRef.current = true;
				setActiveEvent(list[nextIndex]);
				setDragX(0);
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						skipTransitionRef.current = false;
						isAnimatingRef.current = false;
						animTimeoutRef.current = null;
						axisLockRef.current = null;
					});
				});
			}, SWIPE_MS);
		},
		[]
	);

	// Native touch — no react-swipeable scroll lock after horizontal swipe
	useEffect(() => {
		if (!isMobile) return undefined;
		const el = carouselRef.current;
		if (!el) return undefined;

		let startX = 0;
		let startY = 0;
		let lastX = 0;
		let startTime = 0;
		let lastTime = 0;
		let axis = null;
		let dragging = false;

		const clearGesture = () => {
			axis = null;
			dragging = false;
			axisLockRef.current = null;
		};

		const onTouchStart = (e) => {
			if (e.touches.length !== 1) return;
			if (isAnimatingRef.current && !animTimeoutRef.current) {
				isAnimatingRef.current = false;
				skipTransitionRef.current = false;
			}
			const t = e.touches[0];
			startX = lastX = t.clientX;
			startY = t.clientY;
			startTime = lastTime = performance.now();
			clearGesture();
		};

		const onTouchMove = (e) => {
			if (isAnimatingRef.current || e.touches.length !== 1) return;
			const t = e.touches[0];
			const dx = t.clientX - startX;
			const dy = t.clientY - startY;
			const absX = Math.abs(dx);
			const absY = Math.abs(dy);

			if (!axis) {
				if (absX < 12 && absY < 12) return;
				axis = absX > absY ? "x" : "y";
				axisLockRef.current = axis;
				if (axis === "x") setHasInteracted(true);
			}

			// Let the browser own vertical page scroll — never preventDefault
			if (axis !== "x") return;

			if (e.cancelable) e.preventDefault();

			lastX = t.clientX;
			lastTime = performance.now();

			const list = eventsRef.current;
			const idx = list.indexOf(activeEventRef.current);
			let x = dx;
			if (
				(idx <= 0 && dx > 0) ||
				(idx >= list.length - 1 && dx < 0)
			) {
				x = dx * 0.28;
			}

			if (!dragging) {
				dragging = true;
				setIsDragging(true);
			}
			setDragX(x);
		};

		const onTouchEnd = (e) => {
			const wasHorizontal = axis === "x";
			const wasDragging = dragging;
			const endX = e.changedTouches?.[0]?.clientX ?? lastX;
			const endY = e.changedTouches?.[0]?.clientY ?? startY;
			const dx = endX - startX;
			const dy = endY - startY;
			const elapsed = Math.max(performance.now() - startTime, 1);
			const recentElapsed = Math.max(performance.now() - lastTime, 1);
			const vx = (endX - lastX) / recentElapsed;

			clearGesture();

			if (isAnimatingRef.current) return;

			if (!wasHorizontal || !wasDragging) {
				resetDragState();
				return;
			}

			if (Math.abs(dy) > Math.abs(dx) * 1.15) {
				resetDragState();
				return;
			}

			const list = eventsRef.current;
			const idx = list.indexOf(activeEventRef.current);
			const u = unitRef.current || 1;
			const threshold = Math.min(Math.max(u * 0.18, 48), 88);
			const flick =
				Math.abs(vx) > 0.4 || Math.abs(dx) / elapsed > 0.45;
			const goNext =
				dx < -threshold || (dx < -24 && flick && dx < 0);
			const goPrev =
				dx > threshold || (dx > 24 && flick && dx > 0);

			if (goNext && idx < list.length - 1) commitSwipe(idx + 1, -1);
			else if (goPrev && idx > 0) commitSwipe(idx - 1, 1);
			else resetDragState();
		};

		const onTouchCancel = () => {
			clearGesture();
			if (!isAnimatingRef.current) resetDragState();
		};

		el.addEventListener("touchstart", onTouchStart, { passive: true });
		el.addEventListener("touchmove", onTouchMove, { passive: false });
		el.addEventListener("touchend", onTouchEnd, { passive: true });
		el.addEventListener("touchcancel", onTouchCancel, { passive: true });

		return () => {
			el.removeEventListener("touchstart", onTouchStart);
			el.removeEventListener("touchmove", onTouchMove);
			el.removeEventListener("touchend", onTouchEnd);
			el.removeEventListener("touchcancel", onTouchCancel);
		};
	}, [isMobile, activeEvent, resetDragState, commitSwipe]);

	useEffect(
		() => () => {
			if (animTimeoutRef.current) clearTimeout(animTimeoutRef.current);
		},
		[]
	);

	const wrapEvents = ["Proving Grounds"];

	const activeData =
		activeEvent && allEventData[activeYear]
			? allEventData[activeYear][activeEvent]
			: null;

	const carouselSlides = useMemo(() => {
		if (!activeEvent || !allEventData[activeYear]) return [];
		const yearData = allEventData[activeYear];
		const idx = events.indexOf(activeEvent);
		return [
			{
				key: idx > 0 ? events[idx - 1] : "__empty-prev",
				data: idx > 0 ? yearData[events[idx - 1]] : null,
				role: "prev",
			},
			{
				key: activeEvent,
				data: yearData[activeEvent],
				role: "current",
			},
			{
				key: idx < events.length - 1 ? events[idx + 1] : "__empty-next",
				data: idx < events.length - 1 ? yearData[events[idx + 1]] : null,
				role: "next",
			},
		];
	}, [activeEvent, allEventData, activeYear, events]);

	const trackStyle = isMobile
		? {
				transform: `translate3d(${baseX + dragX}px, 0, 0)`,
				transition:
					isDragging || skipTransitionRef.current || !carouselWidth
						? "none"
						: `transform ${SWIPE_MS}ms ${SWIPE_EASE}`,
				gap: `${gap}px`,
		  }
		: undefined;

	const renderInf = (data) => {
		if (!data) return null;
		return (
			<>
				{data.game && (
					<div className="inf-element">
						<div className="icon-container">{getGameLogo(data.game)}</div>
						<div className="inf-text p12">{data.game}</div>
					</div>
				)}
				{data.date && (
					<div className="inf-element">
						<div className="icon-container">
							<CalendarViewMonthIcon />
						</div>
						<div className="inf-text p12">{data.date}</div>
					</div>
				)}
				{data.prize && (
					<div className="inf-element">
						<div className="icon-container">
							<AttachMoneyIcon />
						</div>
						<div className="inf-text p12">{data.prize}</div>
					</div>
				)}
			</>
		);
	};

	const visualCenterRole =
		!isMobile || !unit
			? "current"
			: dragX < -unit * 0.45
				? "next"
				: dragX > unit * 0.45
					? "prev"
					: "current";

	const renderMobileSlide = (slide) => (
		<div
			key={slide.key}
			className={`events-carousel__slide ${
				slide.role === visualCenterRole ? "is-center" : ""
			} ${!slide.data ? "is-empty" : ""} ${
				isDragging ? "is-dragging-slide" : ""
			}`}
			style={{
				flex: slideSize > 0 ? `0 0 ${slideSize}px` : `0 0 calc(100% - ${PEEK_PX * 2}px)`,
			}}
		>
			{slide.data ? (
				<>
					<figure style={{ borderRadius: "32px", opacity: 1 }}>
						<div className="description-image">
							<img src={slide.data.logo} alt={slide.data.title} />
						</div>
					</figure>
					<div className="description-inf description-inf--swipe">
						{renderInf(slide.data)}
					</div>
				</>
			) : null}
		</div>
	);

	return (
		<section id="events" className="events">
			<div className="events-section">
				<div className="events-heading">
					<SlideIn direction="up" delay={100} threshold={0.1}>
						<h2 className="tracking-in-expand">{t("events.title")}</h2>
					</SlideIn>
				</div>
				<SlideIn direction="up" delay={150} threshold={0.1}>
					<div className="events-calendar">
						<div className="calendar-years">
							<ul className="years">
								{["2022", "2023", "2024", "2025", "2026"].map((year) => (
									<li
										key={year}
										className={activeYear === year ? "active" : ""}
										onClick={() => handleYearClick(year)}
									>
										{year}
									</li>
								))}
							</ul>
							{isMobile && events.length > 0 && (
								<div
									className={`events-segments ${
										events.length > 12 ? "is-wrapping" : ""
									}`}
									role="tablist"
									aria-label="Events"
								>
									{events.map((event, index) => (
										<button
											key={event}
											type="button"
											role="tab"
											aria-selected={activeEvent === event}
											aria-label={event}
											className={`events-segments__item ${
												activeEvent === event ? "is-active" : ""
											}`}
											onClick={() => handleSegmentClick(index)}
										/>
									))}
								</div>
							)}
						</div>
						<div className="calendar-events">
							<ul className="events-list">
								{events.map((event) => (
									<li key={event}>
										<button
											className={`button-events
    ${activeEvent === event ? "active" : ""}
    ${
			[
				"ROFLOTURIK",
				"BB League SU",
				"DEADLOCK",
				"CSGORUN S1",
				"DEADLOCK #2",
				"BB League FL",
				"DEADLOCK #3",
				"Noxus League",
				"FME Dota2 #3",
				"Proving Grounds",
				"Woman Cup #2",
				"BB Valorant FL",
				"BB Esports Cup",
				"SQUAD BATTLE",
				"LanDaLan #3",
			].includes(event)
				? "small-font"
				: ""
		}
    ${wrapEvents.includes(event) ? "wrap-text" : ""}
  `}
											onClick={() => setActiveEvent(event)}
										>
											{event}
										</button>
									</li>
								))}
							</ul>
						</div>
						{isMobile ? (
							<div
								className={`calendar-description ${
									hasInteracted ? "interacted" : ""
								}`}
							>
								{activeData && (
									<>
										<div
											ref={carouselRef}
											className={`events-carousel ${
												isDragging ? "is-dragging" : ""
											}`}
										>
											<div
												className="events-carousel__track"
												style={trackStyle}
											>
												{carouselSlides.map(renderMobileSlide)}
											</div>
										</div>
										<article className="article-description">
											<div className="description-text" ref={textRef}>
												<p className="description-text-link">
													{activeData.title}
												</p>
												<p className="description-text-p">
													{activeData.description}
												</p>
											</div>
										</article>
									</>
								)}
							</div>
						) : (
							<TransitionGroup>
								<CSSTransition
									key={activeEvent}
									classNames="slide"
									timeout={400}
									unmountOnExit={false}
								>
									<div className="calendar-description">
										{activeData && (
											<>
												<div className="events-swipe-panel">
													<figure
														style={{ borderRadius: "32px", opacity: 1 }}
													>
														<div className="description-image">
															<img
																src={activeData.logo}
																alt={activeData.title}
															/>
														</div>
													</figure>
												</div>
												<article className="article-description">
													<div className="description-inf description-inf--static">
														{renderInf(activeData)}
													</div>
													<div className="description-text">
														<p className="description-text-link">
															{activeData.title}
														</p>
														<p className="description-text-p">
															{activeData.description}
														</p>
													</div>
												</article>
											</>
										)}
									</div>
								</CSSTransition>
							</TransitionGroup>
						)}
					</div>
				</SlideIn>
			</div>
		</section>
	);
}

export default Events;
